import { AlertCircle, ArrowRight, CheckCircle2 } from "lucide-react";
import { money, num, pct } from "../../lib/format";

const KPI = [
  ["total_opportunities", "Toplam Potansiyel Fırsat", "num"],
  ["corporate_opportunities", "Kurumsal Fırsatlar", "num"],
  ["individual_opportunities", "Bireysel Fırsatlar", "num"],
  ["high_priority_opportunities", "Yüksek Öncelikli", "num"],
  ["customer_count", "Fırsat Bulunan Müşteri", "num"],
  ["current_portfolio_premium", "Mevcut Portföy Primi", "money"],
  ["open_seller_opportunities", "Satıcı Bazında Açık", "num"],
];

export function CrossSellKpis({ data }) {
  return <section className="crosssell-kpis" data-testid="crosssell-kpi-grid">
    {KPI.map(([key, label, type]) => <div data-testid={`crosssell-kpi-${key.replaceAll('_','-')}`} key={key}>
      <span>{label}</span><strong>{type === "money" ? money(data.kpis[key], true) : num(data.kpis[key])}</strong>
    </div>)}
  </section>;
}

export function DraftGate({ count }) {
  return <section className="crosssell-draft-gate" data-testid="crosssell-draft-gate">
    <AlertCircle size={20}/><div><strong>Production mapping onayı bekleniyor</strong>
      <p>{num(count)} kural-müşteri eşleşmesi yalnız <b>taslak analiz adayıdır</b>. Hiçbiri kesin fırsat veya seller pipeline kaydı değildir.</p></div>
    <span>DRAFT / INACTIVE</span>
  </section>;
}

export function ActiveRuleSummary({ items }) {
  if (!items?.length) return null;
  return <section className="active-rule-summary" data-testid="active-rule-summary"><header><strong>Aktif Kural Özeti</strong><span>Opportunity pipeline üretimi</span></header><div className="crosssell-table-wrap"><table><thead><tr><th>Rule</th><th>Opportunity Count</th><th>HIGH / MEDIUM / LOW</th><th>HIGH / REVIEW Confidence</th><th>Assigned Seller Count</th></tr></thead><tbody>{items.map((item) => <tr data-testid={`active-rule-summary-${item.rule_id}`} key={item.rule_id}><td>{item.rule_name}</td><td>{num(item.opportunity_count)}</td><td>{num(item.priority_distribution?.HIGH)} / {num(item.priority_distribution?.MEDIUM)} / {num(item.priority_distribution?.LOW)}</td><td>{num(item.confidence_distribution?.HIGH)} / {num(item.confidence_distribution?.REVIEW)}</td><td>{num(item.assigned_seller_count)}</td></tr>)}</tbody></table></div></section>;
}

export function Pipeline({ items }) {
  return <section className="crosssell-pipeline" data-testid="crosssell-pipeline">
    {items.map((item, index) => <div key={item.status}>
      <span className={item.status === "WON" ? "won" : ""}>{item.status === "WON" ? <CheckCircle2 size={14}/> : num(item.count)}</span>
      <small>{item.label}</small>{index < items.length - 1 && <ArrowRight className="pipe-arrow" size={12}/>} 
    </div>)}
  </section>;
}

export function PerformanceSummary({ data }) {
  return <div className="crosssell-performance-summary">
    <span>Kazanılan<strong>{num(data.kpis.won_count)}</strong></span>
    <span>Dönüşüm<strong>{pct(data.kpis.conversion_rate, 2)}</strong></span>
    <span>Gerçekleşen Prim<strong>{money(data.kpis.realized_premium, true)}</strong></span>
    <span>Gerçekleşen Komisyon<strong>{money(data.kpis.realized_commission, true)}</strong></span>
  </div>;
}